import React, { Component } from 'react';
import PropTypes from 'prop-types';
import Radium from 'radium';
import { semanticColors, greyScaleColors } from '../Globals/styles'

class ConfirmationModal extends Component {
  handleYes = () => {
    this.props.onYesMethod();
    this.props.closeModal();
  };
  render() {
    const { closeModal, text, headerText } = this.props;
    return(
      <div>
        <div style={styles.overlay}></div>
        <div style={styles.wizardContainer}>
          <div>
            <div style={styles.heading}>{headerText}</div>
            <div style={styles.textContainer}>
              {text ? text :
                <div>Er du sikker?
                </div>
              }

            </div>
          </div>
          <div style={styles.buttonsContainer}>
            <button style={styles.buttons} className="btn btn-primary waves-btn" onClick={closeModal}> Nej </button>
            <button style={styles.buttons} className="btn btn-success waves-btn" onClick={this.handleYes}> Ja </button>
          </div>
        </div>
      </div>
    )
  }
}

var styles = {
  overlay: {
    width:'100%',
    height: '100%',
    position: 'absolute',
    top: '0',
    left: '0',
    backgroundColor: greyScaleColors.grey,
    opacity: '0.6',
    zIndex: '10'
  },
  wizardContainer:{
    position: 'absolute',
    top: '50%',
    left: '50%',
    zIndex: '11',
    backgroundColor: semanticColors.default,
    width: '550px',
    height: '200px',
    marginTop: '-165px',
    marginLeft: '-329px',
    padding: '20px 30px'
  },
  heading : {
    borderBottom: '1px solid' + semanticColors.mainBackground,
    paddingBottom: '5px',
    paddingLeft: '5px',
    fontWeight : '800'
  },
  textContainer : {
    paddingTop: '20px'
  },
  buttonsContainer : {
    textAlign : 'right',
    marginTop : '34px'
  },
  buttons: {
    width: '145px',
    height: '35px',
    marginLeft: '10px'
  }
}

ConfirmationModal.propTypes = {
    closeModal: PropTypes.func.isRequired,
    onYesMethod: PropTypes.func.isRequired,
    text: PropTypes.object,
    headerText: PropTypes.string.isRequired
  };
export default Radium(ConfirmationModal);


// WEBPACK FOOTER //
// ./src/App/Common/confirmationModal.jsx